import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';

/**
 * Guard combiné : vérifie d'abord la session via /api/auth/me,
 * puis vérifie que l'utilisateur a au moins un rôle Zazu.
 *
 * - Pas de session → redirection vers la page de login Keycloak
 * - Session sans rôle Zazu → redirection vers /unauthorized
 * - Session avec rôle → accès accordé
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.refreshSession().pipe(
    map((user) => {
      if (!user) {
        authService.login();
        return false;
      }
      if (!user.hasAccess) {
        return router.createUrlTree(['/unauthorized']);
      }
      return true;
    }),
  );
};
